<template>
  <div>
    <el-card class="mx-2">
      <div slot="header" class="clearfix">
        <el-button type="primary" style="float: right;" icon="el-icon-circle-plus-outline" size="small" @click="dialogs.newSeason = true">
          New Season
        </el-button>
      </div>
      <el-row>
        <el-table
          ref="elTable"
          :data="data"
          :row-key="getRowKey"
          style="width: 99%; margin-left: 5px;"
          border
          size="small"
          :header-cell-style="{ background: '#f1f1f5', color: 'black', textAlign: 'center' }"
        >
          <el-table-column label="Sl.No" type="index" align="center" width="100" />
          <el-table-column label="Season" property="label" align="center" />
          <el-table-column label="Status" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.active_status" type="success" size="mini">Active</el-tag>
              <el-tag v-else-if="!scope.row.active_status" type="danger" size="mini">Inactive</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column label="Actions" width="120" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="Make Inactive" placement="bottom">
                <el-button size="mini" type="danger" icon="el-icon-circle-close" circle v-if="scope.row.active_status" />
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="Make Active" placement="bottom">
                <el-button size="mini" type="success" icon="el-icon-circle-check" circle v-if="!scope.row.active_status" />
              </el-tooltip>
            </template>
          </el-table-column> -->
        </el-table>
      </el-row>
    </el-card>

    <!-- #region New Season Modal -->
    <el-dialog :visible.sync="dialogs.newSeason" title="Create New Season">
      <el-form :model="form" label-position="top" ref="ruleForm">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="Season" prop="label" required :rules="[{ required: true, message: 'Season is required' }]">
              <el-input v-model="form.label" placeholder="Season Label"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogs.newSeason = false" class="mr-2">Cancel</el-button>
        <el-popconfirm title="This will disable the current active season and it's data, Do you want to continue?" @confirm="onSave">
          <el-button slot="reference" type="primary">Save</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
    <!-- #endregion -->
  </div>
</template>

<script>
import Axios from "axios";
import { AlertService } from "../../utils/AlertService";

export default {
  name: "Active Year",
  computed: {},
  data() {
    return {
      data: [],
      form: {
        label: "",
      },
      dialogs: {
        newSeason: false,
      },
      isMounted: false,
    };
  },
  methods: {
    getRowKey(row) {
      return row.id;
    },
    async onInit() {
      await this.getActiveYears();
    },
    async getActiveYears() {
      Axios.get(`/active-year`)
        .then((res) => {
          this.data = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async onSave() {
      Axios.post(`/active-year`, {
        label: this.form.label,
        active_status: true,
      })
        .then(() => {
          AlertService.success("New season has been created.");
        })
        .catch((err) => {
          console.log(err);
          AlertService.error(err.response.data.message);
        })
        .finally(async () => {
          this.dialogs.newSeason = false;
          await this.onInit();
        });
    },
  },
  async mounted() {
    await this.onInit();
    this.isMounted = true;
  },
};
</script>
<style>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>
